import React, { Component } from 'react';
import { connect } from 'react-redux';
import Link from '../../shared/Link/Link';

import {
  getCategoryName,
  getSubcategoryName,
} from '../../../redux/modules/categories';
import { getTagName } from '../../../redux/modules/tags';

import './Breadcrumb.scss';

class Breadcrumb extends Component {
  render() {
    const {
      page,
      category,
      categoryName,
      subcategory,
      subcategoryName,
      product,
      keywords,
      discounted,
      tag,
      tagName,
    } = this.props;
    return (
      <ol className="breadcrumb">
        <li className="breadcrumb-item">{capitalizeFirst(page)}</li>
        {!!category && !!page && (
          <li className="breadcrumb-item">
            <Link to={`/${page}/${category}`} activeClassName="active">
              {capitalizeFirst(categoryName)}
            </Link>
          </li>
        )}
        {!!subcategory && !!page && subcategory !== '_' ? (
          <li className="breadcrumb-item">
            <Link
              to={`/${page}/${category}/${subcategory}`}
              activeClassName="active"
            >
              {capitalizeFirst(subcategoryName)}
            </Link>
          </li>
        ) : null}
        {!!product && !!page && !!subcategory && !!product.seoName && (
          <li className="breadcrumb-item">
            <Link
              to={`/${page}/${category}/${subcategory}/${product.seoName}`}
              activeClassName="active"
            >
              {product.name}
            </Link>
          </li>
        )}
        {!!keywords && !!page && (
          <li className="breadcrumb-item">
            <Link to={`/${page}/${keywords}`} activeClassName="active">
              {keywords}
            </Link>
          </li>
        )}
        {!!discounted && (
          <li className="breadcrumb-item">
            <Link to={`/prodotti-in-offerta`} activeClassName="active">
              In offerta
            </Link>
          </li>
        )}
        {!!tag && !!page && (
          <li className="breadcrumb-item">
            <Link to={`/${page}/${tag}`} activeClassName="active">
              {tagName}
            </Link>
          </li>
        )}
      </ol>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    categoryName: getCategoryName(state, ownProps.category),
    subcategoryName: getSubcategoryName(state, ownProps.subcategory),
    tagName: getTagName(state, ownProps.tag),
  };
}

export default connect(mapStateToProps)(Breadcrumb);

const capitalizeFirst = string => {
  if (string && string.length > 0) {
    return string[0].toUpperCase() + string.slice(1).toLowerCase();
  }
  return string;
};
